/**
 * inputChipsAutocompleteDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { isFunction, uniqueId } from 'lodash-es';

inputChipsAutocompleteDirective.$inject = ['$util'];

export function inputChipsAutocompleteDirective($util) {
    const menuContainerClass = `app-input-chips-autocomplete-menu-container-${uniqueId()}`;
    const inputId = `app-input-chips-autocomplete-input-${uniqueId()}`;

    return {
        // language=HTML
        template: `
            <label class="form-field-label">{{ label }}</label>

            <md-chips ng-model="value"
                      ng-ref="chipsController"
                      md-on-add="_onChipAdded($event)"
                      md-require-match="true">

                <md-autocomplete md-selected-item="selectedItem"
                                 md-search-text="ui.searchText"
                                 md-search-text-change="onSearchTextChange()"
                                 md-items="item in search()"
                                 md-item-text="item.label"
                                 md-input-id="${inputId}"
                                 md-menu-container-class="${menuContainerClass}"
                                 md-min-length="0"
                                 md-escape-options="blur clear"
                                 ng-disabled="value.length >= maxChips"
                                 placeholder="{{ placeholder() }}">
                    <md-item-template>
                        <span md-highlight-text="ui.searchText" md-highlight-flags="gi">
                            {{ item.label }}
                        </span>
                    </md-item-template>

                    <md-not-found>
                        No matches found.
                    </md-not-found>
                </md-autocomplete>

                <md-chip-template>
                    {{ $chip.label }}
                </md-chip-template>
            </md-chips>
        `,
        scope: {
            filter: '&?filter',
            items: '=items',
            label: '@label',
            maxChips: '=?maxChips',
            hint: '@hint',
            selectedItem: '=selectedItem',
            value: '=value',
        },
        link: function(scope, element) {
            element.addClass('app-form-field');

            const ui = (scope.ui = {
                searchText: '',
            });

            // Methods
            scope._onChipAdded = _onChipAdded;
            scope.search = search;
            scope.placeholder = placeholder;

            scope.onSearchTextChange = onSearchTextChange;

            /** @type {MdChipsCtrl} */
            const chipsController = element.find('md-chips').controller('mdChips');
            console.log('chipsController', chipsController);
            console.log('element', element[0]);

            const $input = element[0].querySelector(`#${inputId}`);

            console.log('$input', $input);

            if (!Array.isArray(scope.value)) {
                throw '`value` must be an array!';
            }

            if (scope.maxChips) {
                scope.maxChips = parseInt(scope.maxChips);

                if (isNaN(scope.maxChips)) {
                    throw '`max-chips` must be a number';
                }
            }

            function getContainerElement() {
                return document.querySelector(`.${menuContainerClass}`);
            }

            function _onChipAdded() {
                console.log('_onChipAdded');

                $util.nextTickImmediate(() => {
                    _setAutocompleteMenuVisibility(false);
                });
            }

            function onSearchTextChange() {
                console.log(ui.searchText);

                _setAutocompleteMenuVisibility(Boolean(ui.searchText && ui.searchText.length > 0));
            }

            /**
             * @param {!boolean} visible
             * @private
             */
            function _setAutocompleteMenuVisibility(visible) {
                console.log('_setAutocompleteMenuVisibility', visible);
                const containerElement: any = getContainerElement();

                containerElement.style.display = visible ? 'block' : 'none';
            }

            function placeholder() {
                if (scope.maxChips) {
                    return scope.maxChips > scope.value.length ? scope.hint : '';
                }

                return scope.hint;
            }

            function search() {
                let results = null;

                if (isFunction(scope.filter)) {
                    results = scope.filter({
                        query: ui.searchText,
                        items: scope.items,
                    });
                } else {
                    results = scope.items;
                }

                return Promise.resolve(results);
            }
        },
    };
}
